module.exports = __webpack_public_path__ + "img/bg.13844ffb.jpg";